/**
 * Use this enum for logging eventIds that power alerts and/or dashboard
 * OR
 * for shared eventIds across multiple logs
 */
export enum EventId {
  /**
   * EventId for when a user is ineligible for a flow, powers CWP ineligible dashboard
   * @see https://vanguardgroup.splunkcloud.com/en-US/app/vg_retail_prod/cwp_ineligible
   */
  INELIGIBLE_PAGE_ROUTE = 'ineligible_page_route',
}
